import * as React from 'react';


type PreviewCommonProps = {
  className?: string;
  name?: string;
  previewSize?: string;
};
type PreviewSrcProps = {
  src: string;
  srcdoc?: undefined;
} & PreviewCommonProps;
type PreviewSrcDocProps = {
  srcdoc: string;
  src?: undefined;
} & PreviewCommonProps;
type PreviewIframeProps = PreviewSrcProps | PreviewSrcDocProps;

const PreviewIframe = ({
  src,
  className,
  name,
  srcdoc,
  previewSize,
}: PreviewIframeProps): React.ReactElement<React.ComponentProps<'iframe'>> => {
  const [iframeHeight, setIframeHeight] = React.useState(0);
  const iframeRef = React.useRef<HTMLIFrameElement | null | undefined>(null);

  React.useEffect(() => {
    setIframeHeight(0);
  }, [src, srcdoc]);

  const measureOnLoad = React.useCallback(() => {
    if (iframeRef.current !== null) {
      setIframeHeight(
        // @ts-expect-error - TS18047 - 'iframeRef.current.contentWindow' is possibly 'null'. | TS2345 - Argument of type 'number | undefined' is not assignable to parameter of type 'SetStateAction<number>'.
        iframeRef.current?.contentWindow.document.body.scrollHeight,
      );
    }
  }, [iframeRef]);

  React.useEffect(() => {
    measureOnLoad();
  }, [previewSize]);

  React.useEffect(() => {
    if (srcdoc && iframeRef.current) {
      iframeRef.current.srcdoc = srcdoc;
    }
  }, [srcdoc]);

  return (
    <iframe
      src={src}
      name={name}
      onLoad={measureOnLoad}
      // @ts-expect-error - TS2322 - Type 'RefObject<HTMLIFrameElement | null | undefined>' is not assignable to type 'Ref<HTMLIFrameElement> | undefined'.
      ref={iframeRef}
      scrolling="yes"
      // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'number'.
      marginHeight="0px"
      // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'number'.
      marginWidth="0px"
      frameBorder="0"
      className={className}
      style={{
        maxHeight: iframeHeight,
        height: iframeHeight,
      }}
      sandbox="allow-same-origin"
    />
  );
};

export default PreviewIframe;
